import { TranslateService } from '@ngx-translate/core';

import { DottedKeyToFlatKey } from './dottedkey-to-flatkey.helper';

// #region MapFacetValuesToFormSelectOptions

export const translateOrDefaultToValue = (
    filterName: string,
    filterValue: string,
    translateService: TranslateService
): string => {
    const flatKey = DottedKeyToFlatKey(filterName);
    const translateKey = `overrides.${flatKey}.${filterValue}`;
    const translation: string = translateService.instant(translateKey);

    return translation === translateKey ? filterValue : translation;
};

// #endregion
